/**
 * Helper class for object level operations
 */
export class ObjectUtil {
  /**
   * Creates a deep copy of an object. Please make sure it doesn't contain any curcular references!
   * @param obj The object to copy
   * @returns A deep copy of the object
   */
  public static deepCopy(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }
}
